<template>
	<div class="hit-container">
		<h1 class="hit-html-h1">{{ $t('message.imprint') }}</h1>

			<div class="hit-form-group" v-html="imprint" />

	</div>
</template>
<script>

import de from 'raw-loader!@shared/language/imprint/de_DE.txt'

var imprint = {
  'de': ''
}

imprint.de = de

export default {

  name: 'imprint',
  data () {
    var lang = this.$route.params.lang

    if (typeof imprint[lang] !== 'string') { lang = 'de' }

    return {
      imprint: this.$nl2br(imprint[lang])
    }
  }

}
</script>

<style scoped>

</style>
